import { Box } from '@bechtel/gds';
import styled, { css } from 'styled-components';

export const ExternalLinkStyled = styled(Box).attrs({
  display: { sm: 'flex' },
  alignItems: { sm: 'center' },
  justifyContent: { sm: 'center' },
  alignSelf: { sm: 'center' },
})`
  ${({ theme }) =>
    css`
      border-radius: ${theme.spacings[100]};
      cursor: pointer;
      height: ${theme.spacings[600]};
      width: ${theme.spacings[600]};
      z-index: 1;
    `}
`;
